import { useState, useEffect, useCallback } from 'react';
import quarkusApi from '../../../../../api/quarkusApi';

// Histórico de retificações de um procedimento (antes/depois de cada correção), mais recente primeiro.
export function useProcedureRectifications(procedureId) {
  const [rectifications, setRectifications] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchRectifications = useCallback(() => {
    if (!procedureId) return;
    setLoading(true);
    quarkusApi
      .get(`/procedures/${procedureId}/rectifications`, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .then((returnFromApi) => setRectifications(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
      })
      .finally(() => setLoading(false));
  }, [procedureId]);

  useEffect(() => {
    fetchRectifications();
  }, [fetchRectifications]);

  return { rectifications, isLoading, error, refetch: fetchRectifications };
}
